module.exports = __webpack_public_path__ + "static/media/DJ.a9a87547.png";